import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { BoardsTable } from '@/features/kanban/components/admin/BoardsTable';

export const Route = createFileRoute('/_authenticated/admin/clients-config')({
  component: ClientsConfigPageRoute,
});

function ClientsConfigPageRoute() {
  return (
    <PermissionGate permission={Permission.NOTION_CONFIG}>
      <ClientsConfigPage />
    </PermissionGate>
  );
}

function ClientsConfigPage() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6">Clientes Configs</h1>
      <p className="text-muted-foreground mb-4">
        Configure os boards do Notion que serão sincronizados no Kanban.
      </p>
      <BoardsTable />
    </div>
  );
}
